{
  "version": 1,
  "asset_id": "913697ae-723b-4ef3-bbea-a7c897f200e3",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/913697ae-723b-4ef3-bbea-a7c897f200e3/metal-roof-installation-citrus-county-fl-1600.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/913697ae-723b-4ef3-bbea-a7c897f200e3/metal-roof-installation-citrus-county-fl-1600.avif",
  "original_filename": "metal-roof-installation-citrus-county-fl-1600.avif",
  "size": 92482,
  "content_type": "image/avif",
  "created_at": "2026-07-16T15:35:54Z"
}
